import {
  createandgetTagEndPoint,
  deleteTagHierarchyEndPoint,
  deleteSiteLabelEndPoint
} from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import { getRandomUUID } from "../../Token";
import { handleApiError } from "../../global/utility/Utils";
import {
  getTagHierarchy,
  getUserSitesData,
  processNestedTags,
} from "../../model/reportService";

export const fetchTagDataForCountries = async (activeSession, kindtype = "ts.tag.country", account = "") => {
  try {
    const response = await axiosInstance.post(createandgetTagEndPoint(), {
      accountname: account && account.trim() ? account : activeSession.accountId,
      filter: {
        $selection: {
          kind: kindtype,
        },
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw "error";
  } catch (e) {
    console.log(e);
    const errorMessage = e?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to fetch sites, please reload the page.");
    return [];
  }
};

export const fetchSitesForBillingAccount = async (accountId, userId, isAdmin) => {
  const scopedSession = { accountId, userId };
  try {
    const countryData = await fetchTagDataForCountries(scopedSession);

    const [hierarchyResults, userSiteData] = await Promise.all([
      Promise.all(
        (countryData || []).map(async (country) => {
          try {
            const response = await getTagHierarchy(
              { maxdepth: 8 },
              { id: country.id },
              scopedSession
            );
            return { ...country, nestedtags: [...response] };
          } catch (error) {
            console.error("Error fetching tag hierarchy:", error);
            return null;
          }
        })
      ),
      getUserSitesData(scopedSession),
    ]);

    const combinedResponse = hierarchyResults.filter(Boolean);
    const processedNestedData = processNestedTags(combinedResponse);

    if (isAdmin) {
      return processedNestedData?.sites || [];
    }
    return (userSiteData || []).filter((item) =>
      processedNestedData?.sites?.some((data) => data?.id === item?.id)
    );
  } catch (error) {
    console.error("Error fetching sites for billing account:", error);
    return [];
  }
};

export const handleSiteDelete = async (key, activeSession) => {
  if (!key) {
    console.error("ID is empty");
    return;
  }
  try {
    const payload = {
      accountname: activeSession?.accountId,
      filter: null,
      resourceidentifier: {
        id: key,
      },
    };

    const response = await axiosInstance.post(
      deleteTagHierarchyEndPoint(),
      payload
    );
    const data = response.data;
    return data ?? true;
  } catch (error) {
    console.error("Error deleting tag hierarchy:", error);
    const errorMessage = error?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to delete site, please try again.");
    return false;
    //throw error;
  }
};
export const handleSiteLevelTagsDelete = async (key, activeSession) => {
  if (!key) {
    return false;
  }
  try {
    const payload = {
      accountname: activeSession?.accountId,
      filter: null,
      resourceidentifier: {
        id: key,
      },
    };

    const response = await axiosInstance.post(
      deleteSiteLabelEndPoint(),
      payload
    );
    const data = response.data;
    return data !== undefined ? data : "";
  } catch (error) {
    console.error("Error deleting tag hierarchy:", error);
    const errorMessage = error?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to delete site, please try again.");
    return false;
    //throw error;
  }
};
